export enum ArticlesActionTypes {
    fetchArticles = 'FETCH_ARTICLES',
    fetchArticle = 'FETCH_ARTCILE',
    deleteArticle = 'DELETE_ARTICLE',
    submitArticle = 'SUBMIT_ARTICLE',
    setSelectedArticle = 'SET_SELECTED_ARTICLE',
}
